module.exports = __webpack_public_path__ + "static/media/advantage-4.26be4937.png";